// extracted by mini-css-extract-plugin
export default {"chevron":"chevron_chevron__E+wIS"};